import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.parkParcels.title',
    defaultMessage: 'Park parcel',
    description: 'title of the park parcel page',
  },
  search: {
    placeholder: {
      id: 'pages.parkParcels.search.placeholder',
      defaultMessage: 'Parcel number',
      description: 'Placeholder of the search bar on the park parcel page',
    },
  },
  feedback: {
    parcelAlreadySent: {
      id: 'pages.parkParcels.feedback.parcelAlreadySent',
      defaultMessage: 'Parcel already sent',
      description: 'Parcel already sent message on the park parcel page',
    },
    parcelNotFound: {
      id: 'pages.parkParcels.feedback.parcelNotFound',
      defaultMessage: 'Parcel not found',
      description: 'Parcel not found message on the park parcel page',
    },
  },
};

export default defineMessages(translations);
